import {useCallback} from 'react';
import deleteProgressDoc from '../../api/progress/deleteProgressDoc';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export default function useDeleteProgress() {
  const deleteProgress = useCallback(async (examModuleId: string) => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) {
      throw new Error('Not authenticated');
    }

    await deleteProgressDoc(uid, examModuleId);
  }, []);

  const {loading, error, refetch} = useFunctionRun(deleteProgress, {
    skipLoadOnMount: true,
  });

  return {deleteProgress: refetch, loading, error};
}
